import { useEffect } from 'react';
import { useColorScheme } from '@mui/material';

import { isEmbedAtBoot, onEmbedTheme } from '@/utils/embed';
import { EMBED_DARK_CSS } from '@/utils/embedPalette';

/*
 * 글로벌 소듀 안에 끼워 넣었을 때만 부모 창의 화면 테마를 따른다 (src/utils/embed.ts).
 * html 에 data-sodu-embed 를 붙이고 어두운 색 변수(embedPalette.ts)를 넣는다.
 * 끼워 넣지 않은 화면에서는 아무것도 하지 않는다.
 */
export default function EmbedThemeSync() {
    const { setMode } = useColorScheme();

    useEffect(() => {
        if (!isEmbedAtBoot()) return;
        const root = document.documentElement;
        root.setAttribute('data-sodu-embed', '');
        const style = document.createElement('style');
        style.setAttribute('data-sodu-embed-dark', '');
        style.textContent = EMBED_DARK_CSS;
        document.head.appendChild(style);
        const off = onEmbedTheme((mode) => setMode(mode));
        return () => {
            off();
            style.remove();
            root.removeAttribute('data-sodu-embed');
        };
    }, [setMode]);

    return null;
}
